import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import Checkbox from "../components/Checkbox";
import Textarea from "../components/Textarea";
import "./MultipleChoiceOther.scss";

const MultipleChoiceOther = ({
  question,
  fieldName,
  value,
  error,
  otherTextValue,
  otherTextError,
  setFieldValue,
  setFieldTouched,
}) => {
  const { t } = useTranslation(["survey"]);
  const handleCheckboxChange = e => {
    const optionValue = e.target.value;
    const currentValues = value || [];

    let newValues;
    if (e.target.checked) {
      newValues = [...currentValues, optionValue];
    } else {
      newValues = currentValues.filter(v => v !== optionValue);
      // Clear other text if unchecking "other"
      if (optionValue === "other") {
        setFieldValue(`${fieldName}_other_text`, "");
      }
    }

    setFieldValue(fieldName, newValues);
    setFieldTouched(fieldName, true);
  };

  const handleOtherTextChange = e => {
    setFieldValue(`${fieldName}_other_text`, e.target.value);
  };

  const handleOtherTextBlur = () => {
    setFieldTouched(`${fieldName}_other_text`, true);
  };

  const isChecked = option => {
    return value && Array.isArray(value) && value.includes(option);
  };

  return (
    <div className="multiple-choice-other">
      <div className="multiple-choice-other__header">
        {question.question && (
          <h2 className="multiple-choice-other__title">
            {question.question}
            {question.required && (
              <span className="multiple-choice-other__required">*</span>
            )}
          </h2>
        )}

        <p className="multiple-choice-other__subtitle">
          {question.helper_text}
        </p>
      </div>

      <div className="multiple-choice-other__options">
        {question.options &&
          question.options.map((option, index) => (
            <Checkbox
              key={`${fieldName}-${index}`}
              id={`${fieldName}-${index}`}
              name={fieldName}
              value={option}
              label={option}
              checked={isChecked(option)}
              onChange={handleCheckboxChange}
            />
          ))}

        {/* Other option */}
        <div className="multiple-choice-other__other-container">
          <Checkbox
            id={`${fieldName}-other`}
            name={fieldName}
            value="other"
            label={t("survey:wizard.other")}
            checked={isChecked("other")}
            onChange={handleCheckboxChange}
          />

          {isChecked("other") && (
            <div className="multiple-choice-other__other-text">
              <Textarea
                name={`${fieldName}_other_text`}
                value={otherTextValue || ""}
                onChange={handleOtherTextChange}
                onBlur={handleOtherTextBlur}
                placeholder={t("survey:wizard.placeholderOpenQuestion")}
                rows={3}
                className={
                  otherTextError ? "multiple-choice-other__textarea--error" : ""
                }
              />
              {otherTextError && (
                <div className="multiple-choice-other__error">
                  {otherTextError}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {error && <div className="multiple-choice-other__error">{error}</div>}
    </div>
  );
};

MultipleChoiceOther.propTypes = {
  question: PropTypes.shape({
    question: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  fieldName: PropTypes.string.isRequired,
  value: PropTypes.array,
  error: PropTypes.string,
  otherTextValue: PropTypes.string,
  otherTextError: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
};

MultipleChoiceOther.defaultProps = {
  value: [],
  error: null,
  otherTextValue: "",
  otherTextError: null,
};

export default MultipleChoiceOther;
